import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import { TextField } from "@material-ui/core";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Formik } from "formik";
import * as Yup from "yup";
import { Autocomplete, Button, FormHelperText } from "@mui/material";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { ProcessEnum, ProcessEnumDisplayLabel } from "../../Types/Enum";
import { useSnackbar } from "notistack";

const ProcessViewDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const [processView, setProcessView] = useState(props.data);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formRef = useRef<any>();
  const [value, setValue] = useState({});

  useEffect(() => {
    setProcessView(props.data);
  }, [props.data]);


  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const editProcessView = async (data: any) => {

    const url = `${process.env.REACT_APP_API_ORIGIN}/v1/process/${processView.process.id}`;

    axiosInstance
      .put(url, {
        resume_id: processView.process.resume_id,
        country_process_id: processView.process.country_process.id,
        status: data.status,
        note: data.note ? data.note : "",
      })
      .then((response) => {

      })
      .catch((error) => {
        enqueueSnackbar("Process Updated Unsuccessfull!!!", {
          variant: "error",
        });
      });


    enqueueSnackbar("Process Updated Successfully!!!", { variant: "success" });

    handleClose();
  };
  const refresh = () => {
    // it re-renders the component
    window.location.reload();
  };

  return (
    <>
      {" "}
      {processView == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit Pocess :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}

          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={processView}
              initialTouched={{ zip: true }}
              //   validationSchema={Yup.object().shape({
              //     title: Yup.string()
              //       .required("Title is Required")
              //       .max(125, "Title must not be greater than 15 characters"),

              //     type: Yup.string()
              //       .max(8, "Type must not be greater than 8 characters")
              //       .required("Type is Required"),
              //   })}
              onSubmit={editProcessView}
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-1 ">
                  <div className="flex flex-col space-y-1 mt-4 mr-6 mb-4">
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={[
                        ProcessEnum.processing,
                        ProcessEnum.completed,
                        ProcessEnum.rejected,
                      ]}
                      getOptionLabel={(option) =>
                        ProcessEnumDisplayLabel[option]
                      }
                      onChange={(e, value) => setFieldValue("status", value)}
                      sx={{ width: 245, }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="status"
                          label="Status"
                          variant="outlined"
                          required
                          // onChange={handleChange}
                          value={values.status || ""}
                          placeholder={
                            values == ""
                              ? "Processing"
                              : ProcessEnumDisplayLabel[processView.status]
                          }
                          size="small"
                          error={Boolean(touched.status && errors.status)}
                          helperText={
                            errors.sub_agent_id &&
                            touched.sub_agent_id &&
                            String(errors.sub_agent_id)
                          }
                        />
                      )}
                    />

                    {/* <TextField
                      id="outlined-multiline-flexible"
                      multiline
                      maxRows={2}
                      variant="outlined"
                      onChange={handleChange}
                      value={values.status}
                      placeholder="Enter the status"
                      size="small"
                      name="status"
                      inputProps={{
                        style: {
                          height: "20px",
                          fontSize: "14px",
                        },
                      }}
                      error={Boolean(errors.status && touched.status)}
                      helperText={
                        errors.status && touched.status && String(errors.status)
                      }
                    /> */}
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <TextField
                      id="outlined-multiline-flexible"
                      multiline
                      required
                      label="Note"
                      minRows={10}
                      variant="outlined"
                      onChange={handleChange}
                      value={values.note || ""}
                      placeholder="Enter the Note"
                      size="small"
                      name="note"
                      inputProps={{
                        style: {
                          height: "30px",
                          fontSize: "14px",
                        },
                      }}
                      error={Boolean(errors.note && touched.note)}
                      helperText={
                        errors.note && touched.note && String(errors.note)
                      }
                    />
                  </div>

                  <div>
                    <div className="flex py-3 px-3 space-x-4 justify-center">
                      <Button
                        variant="contained"
                        color="primary"
                        className="ml-4 my-1"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Update
                      </Button>

                      <Button
                        variant="contained"
                        color="secondary"
                        className="ml-4 my-1"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default ProcessViewDialogBox;
